var map = {
	"./ALZA.svg": "2ec8",
	"./COMGATE.svg": "9010",
	"./CZC.svg": "de5f",
	"./EKIS.svg": "32c2",
	"./HC_MAPP.svg": "3129",
	"./HC_OL.svg": "3fa5",
	"./HOMECREDIT.svg": "fa84",
	"./MALL.svg": "6f65",
	"./TESCO.svg": "c762",
	"./TESTSHOP.svg": "3c7c",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";